export class FacturationMessage {
    constructor() {}

    Email = 'stepper.form.facturation.Email';
    Intitule = 'stepper.form.facturation.Intitule';
    Denomination = 'stepper.form.facturation.Denomination';
    SIRET = 'stepper.form.facturation.SIRET';
    Nserviceexecutant = 'stepper.form.facturation.Nserviceexecutant';
    Nengagementjuridique = 'stepper.form.facturation.Nengagementjuridique';
    NumeroBonCommande = 'stepper.form.facturation.NumeroBonCommande';
    IdentifiantAdressage = 'stepper.form.facturation.IdentifiantAdressage';
    IdentifiantAdressageChoisir = 'stepper.form.facturation.IdentifiantAdressageChoisir';
    TypeEntite = 'stepper.form.facturation.TypeEntite';
    TypeEntitePublique = 'stepper.form.facturation.TypeEntitePublique';
    TypeEntitePriveeAssujettie = 'stepper.form.facturation.TypeEntitePriveeAssujettie';
    Serviceoudestinataire = 'stepper.form.facturation.Serviceoudestinataire';
    Immeublebatiment = 'stepper.form.facturation.Immeublebatiment';
    Numerolibellevoie = 'stepper.form.facturation.Numerolibellevoie';
    Complementadresseboitepostale = 'stepper.form.facturation.Complementadresseboitepostale';
    Codepostal = 'stepper.form.facturation.Codepostal';
    Pays = 'stepper.form.facturation.Pays';
    tvaIntracommunautaire = 'stepper.form.facturation.tvaIntracommunautaire';
    Telecopieurannonceur = 'stepper.form.facturation.Telecopieurannonceur';
    IdentifiantannonceurBoampWeb = 'stepper.form.facturation.IdentifiantannonceurBoampWeb';
    MailBoampWeb = 'stepper.form.facturation.MailBoampWeb';
    Ville = 'stepper.form.facturation.ville';
    Verifier = 'stepper.form.facturation.Verifier';
    InfobulleSiret = 'stepper.form.facturation.InfobulleSiret';
    InfobulleTypeEntite = 'stepper.form.facturation.InfobulleTypeEntite';
}

